import React from "react";
const Preset6 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("rect", { x: "29", y: "21", width: "54", height: "42", rx: "4", fill: "url(#paint0_linear_6001_4899)" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M38.8655 46.6616L29 54.551V59C29 61.2091 30.7909 63 33 63H79C81.2091 63 83 61.2091 83 59V49.8571L72.5476 41.4984C71.4521 40.6223 69.8957 40.6223 68.8003 41.4984L52.4783 54.551L42.6128 46.6616C41.5173 45.7856 39.961 45.7856 38.8655 46.6616Z",
        fill: "url(#paint1_linear_6001_4899)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "29", y: "85", width: "54", height: "8", rx: "2", fill: "#116DFF" }),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "70", width: "48", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement("rect", { x: "49", y: "75", width: "3", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("rect", { x: "53", y: "75", width: "9", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("circle", { cx: "47", cy: "36", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4899",
        x1: "56",
        y1: "21",
        x2: "56",
        y2: "63",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4899",
        x1: "56",
        y1: "40",
        x2: "56",
        y2: "63",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset6
};
//# sourceMappingURL=Preset6.js.map
